module.exports = __webpack_public_path__ + "static/media/TAWProject.f90b1775.png";